export default __webpack_public_path__ + "static/media/gown.1cf78a9f.png";